/*
 * @Author: J_Nan
 * @Date: 2021-06-22 15:42:37
 * @LastEditors: J_Nan
 * @LastEditTime: 2021-06-22 15:43:23
 */
export function formatDuraton(time){
  if(time > -1){
      var hour = Math.floor(time/3600);
      var min = Math.floor(time/60) % 60;
      var sec = time % 60;
      if(hour < 10) {
          time = '0'+ hour + ":";
      } else {
          time = hour + ":";
      }

      if(min < 10){
          time += "0";
      }
      time += min + ":";

      if(sec < 10){
          time += "0";
      }
      time += sec;
  }
  return time;
}